

import book1 from "@/assets/images/main/books/book1.png"
import book2 from "@/assets/images/main/books/book2.png"
import book3 from "@/assets/images/main/books/book3.png"
import book4 from "@/assets/images/main/books/book4.png"

import isMobile from "@/mixins/isMob";
import ClientHead from "@/components/main/core/ClientHead.vue"
import PricingSection from "@/components/main/pricing/PricingSection"
import RedSection from "@/components/main/core/RedSection.vue"
import BoxSection from "@/components/main/BoxSection.vue"
import CheckBox from "@/components/main/core/CheckBox.vue"
import VueSlickCarousel from "vue-slick-carousel"
import SpinnerButton from "@/components/main/buttons/SpinnerButton";

export default {
  head() {
    const title = 'Cheater Lookup Website - Catch a Cheating Partner | iFindCheaters';
    const description = 'Explore iFindCheaters range of products designed to help you investigate potential infidelity & Catch a Cheating Partner Online. From social media checks to Tinder Blaster, start your journey towards the truth today. Scan your partner now.';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Catch a Cheater, Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites, Tinder Blaster, potential cheaters lookup'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products-services/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Price",
            }],
          }
        }
      ]
    };
  },

  name: "products-services",
  layout: 'clientLayout',
  data() {
    return {
      books: [
        {
          img: book1,
          title: 'Mating in Captivity',
          teaser: 'The Devil is in the details, so is desire! It is not grand gestures but the little things you do for and say to your partner that keep you always on their mind. Small actions have super impact on keeping your love alive.',
          price: '$12,5',
          booksHover: false,
        },
        {
          img: book2,
          title: 'What Do You Really Want?',
          teaser: 'Popular media bombards us with ‘ideal’ relationship models. Reality check: what makes you happy and connects you and your partner may be nothing like those ‘ideals’. Focus on what you really want, it will come.',
          price: '$12,5',
          booksHover: false,
        },
        {
          img: book3,
          title: 'Overcoming Infidelity',
          teaser:'If you have had your heart broken it can be hard to trust again. Learn how to take stock of the situation and decide if your relationship is worth fighting for. If you are moving on learn how to protect yourself in future.',
          price: '$12,5',
          booksHover: false,
        },
        {
          img: book4,
          title: 'LOOK BEFORE YOU LEAP',
          teaser: 'Learn the subtle and not so subtle differences between ‘dating’ and ‘relationship’ status. This guide gives you tips to navigate the new. It also offers hints at when it’s the right time to take things to the next level.',
          price: '$12,5',
          booksHover: false,
        }
      ],
      settings: {
        "dots": true,
        "infinite": true,
        "centerMode": true,
        "centerPadding": "20px",
        "slidesToShow": 3,
        // "slidesToScroll": 1,
        "variableWidth": true,
        "swipeToSlide": true

        // "dots": true,
        // "infinite": true,
        // "centerMode": true,
        // "initialSlide": 2,
        // "speed": 500,
        // "slidesToShow": 3,
        // "slidesToScroll": 1,
        // "swipeToSlide": true,
        // "pauseOnHover": true,
        // "swipeToSlide": true

        // "dots": true,
        // "centerMode": true,
        // "centerPadding": "20px",
        // "focusOnSelect": true,
        // "variableWidth": true,
        // "autoplay": true,
        // "infinite": true,
        // "speed": 500,
        // "slidesToShow": 1,
        // "slidesToScroll": 1,
        // "edgeFriction": 0.35,
      }
    }
  },
  mounted() {

  },
  methods: {
    showNext() {
      this.$refs.carousel.next()
    },
    showPrev() {
      this.$refs.carousel.prev()
    },
  },
  mixins: [isMobile],
  components: {ClientHead, PricingSection, BoxSection, RedSection, CheckBox, VueSlickCarousel, SpinnerButton}
}
